/* eslint-disable */
import Persister from '../../../utils/LocalStoragePersister';

const mutations = {
    /* Connexion part */
    loginUser(state, user) {
      state.informations['firstName'] = user.firstName;
      state.informations['lastName'] = user.lastName;
      state.informations['token'] = user.token;
      state.informations['reference'] = user.reference;
      state.informations['permissions'] = user.permissions;
      state.informations['connected'] = true;
      state.informations['leftPaidVacations'] = user.information.leftPaidVacations;
      state.informations['freeHoursAvailable'] = user.information.freeHoursAvailable;
      if (user.avatar) {
        state.informations['picture'] = '/img/avatars/' + user.avatar;
      }
      Persister.set('user_token', user.token);
      Persister.set('user_permissions', JSON.stringify(user.permissions));
      Persister.set('user_information', JSON.stringify({
        firstName: user.firstName,
        lastName: user.lastName,
        reference: user.reference,
        information: {
          leftPaidVacations: user.information.leftPaidVacations,
          freeHoursAvailable: user.information.freeHoursAvailable,
          picture: user.avatar
        }
      }));
        window.axios.defaults.headers.common = {
            'Authorization': 'Bearer ' + user.token
        };
    },

    logoutUser(state) {
        state.informations = {
          picture: require("@/assets/images/users/user.jpg"),
          permissions: [],
          connected: false,
          leftPaidVacations: 0,
          freeHoursAvailable: 0,
        };
        Persister.delete('user_token');
        Persister.delete('user_permissions');
        Persister.delete('user_information');
        window.axios.defaults.headers.common = {
            'Authorization': undefined
        }
    },

    setNotifications(state, notifications) {
      state.notifications = notifications;
    },

    addNotification(state, notification) {
        state.notifications.unshift(notification);
    },

    readAllNotifications(state) {
      state.notifications = state.notifications.map((notification) => {
        notification.read = true;
        return notification
      })
    },

    setListUserModel(state, model) {
        state.listFormModel = model;
    },

    resetListTableState(state) {
      state.listTableState = {
        page : 1,
        perPage: 10,
        field : 'Date de création',
        ascending: false,
      };
    },

    setUserAccounting(state, value) {
        state.informations.accounting = value;
    },

    setUserInfo(state, value) {
      state.userInfoModal = value;
    },

    setUserId(state, value) {
      state.userId = value;
    },

    setNavBar(state, value) {
      state.showNavBar = value;
    },

    setCollapse(state, value) {
      state.isCollapse = value;      
    }
};

export default mutations;
